import i18n from "i18next";
import enUsTrans from "./locales/en.json";
import zhCnTrans from "./locales/zh.json";
import LanguageDetector from 'i18next-browser-languagedetector';
import {
    initReactI18next
} from 'react-i18next';

let lang = 'en'
if (navigator.language === 'zh-CN') {
    lang = 'zh'
}

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enUsTrans,
            },
            zh: {
                translation: zhCnTrans,
            },
        },
        //默认语言
        fallbackLng: lang,
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    }).then(r => {})


export default i18n;
